import React from "react";
import { array, string } from "prop-types";
import { Link } from "@quintype/components";

import { getBanglaDate } from "../../utils/utils";

import "./homeComments.m.css";

const HomeComments = ({ list, lang }) => {
  const commentList = list.slice(0, 3);
  const timeStyle = `${lang}-time comment-at`;

  return (
    <div styleName="container">
      <div styleName="comments">
        {commentList.map((item, index) => (
          <a key={index} href={item.url}>
            <div>
              <p styleName="comments-msg">
                {item.comments.map((element, elementIndex) => {
                  if (element.isMentioned) {
                    return (
                      <span key={elementIndex} styleName="user-bold">
                        @{element.link}&nbsp;
                      </span>
                    );
                  }

                  return <span key={elementIndex}>{element.message}&nbsp;</span>;
                })}
              </p>
              <span>- আপনার মন্তব্য প্রকাশিত হয়েছে</span>
            </div>
            <time styleName={timeStyle}>{getBanglaDate(new Date(item.createdAt).getTime() / 1000)}</time>
          </a>
        ))}
      </div>

      {/* See All */}
      {list.length > 3 ? (
        <Link href="my-comments" styleName="see-all">
          সব দেখুন <i styleName="nav-right"></i>
        </Link>
      ) : null}
    </div>
  );
};

HomeComments.propTypes = {
  list: array.isRequired,
  lang: string
};

export default HomeComments;
